import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var False = props => {
  var {
    False: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'False');
  return null;
};
False.displayName = 'JVR.False';